/**
 * Add a prefix to a path
 * @param {Path} path Path to update
 * @param {Path} [prefix=null] Prefix to add to the path
 * @return {Path} The updated path
 */
function addPathPrefix(path, prefix = null) {
  if (!path) { throw new Error(`Invalid path: ${path}`); }
  if (!prefix) { return path; }
  return `${prefix}.${path}`;
}

module.exports = addPathPrefix;
